

<ion-content class="overflow-auto" *ngIf="userProfile">
  <div class="d-flex flex-row justify-content-start content-container">

    <div class="d-flex flex-column justify-content-start w-100">
      <div class="user-profile-info">
        <ion-row class="overlay-container">
          <ion-col size-md="6" size="12">
            <ion-row>
              <ion-col size="12">

                <div class="user-details d-flex flex-column mt-md-2 py-2 px-2">

                  <div class="mx-2 d-flex flex-column">

                    <ion-label class="d-flex align-items-center profile-info mb-md-3 mb-2" *ngIf="userProfile?.firstName || userProfile?.lastName">
                      <ion-icon alot="start" name="person-circle-outline" class="me-1"></ion-icon>
                      {{userProfile?.firstName}} {{userProfile?.lastName}}
                    </ion-label>

                    <ion-label class="d-flex align-items-center profile-info mb-md-3 mb-2" *ngIf="userProfile?.emailId">
                      <ion-icon name="mail-outline" class="me-1"></ion-icon>
                      {{userProfile?.emailId}}
                    </ion-label>

                  </div>
                  <div class="mx-2 d-flex flex-column" >

                    <ion-label class="d-flex align-items-center profile-info mb-md-3 mb-2" *ngIf="userProfile?.addressModels[0]?.city">
                      <ion-icon name="location-outline" class="me-1"></ion-icon> 
                      {{userProfile?.addressModels[0]?.city}}
                    </ion-label>

                    <ion-label class="d-flex align-items-center profile-info mb-md-3 mb-2" *ngIf="userProfile?.phoneNumber">
                      <ion-icon name="call-outline" class="me-1"></ion-icon>
                      {{userProfile?.phoneNumber}}
                    </ion-label>

                  </div>
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
          <ion-col size-md="6" size="12" class="button-container">

            <div class="d-flex flex-nowrap flex-sm-wrap pt-lg-4 pb-3 justify-content-end  align-items-lg-center w-100">

              <ion-button class="mx-sm-1 btn-edit" (click)="handleEditProfile()">
                <ion-icon slot="start" name="create-outline"  class="me-1 edit-icon"></ion-icon>
                Update Profile
              </ion-button>

              <ion-button class="mx-sm-1 btn-address" (click)="handleAddAdress()">
                <ion-icon slot="start" name="location-outline" class="me-1 address-icon"></ion-icon>
                New Address
              </ion-button>
              
            </div>
          </ion-col>
        </ion-row>
        
      </div>
      <div class="address-information">
        <ion-row *ngIf="userProfile?.addressModels.length > 0; else noAddressContent" class="py-2">

          <ion-col size-xl="4" size-md="6" size="12" *ngFor="let address of userProfile?.addressModels" class="d-flex">
            <ion-card class="address-card">
        
              <ion-card-header class="address-card-header">
                <ion-card-title class="address-type">{{ address.addressType }}</ion-card-title>

                <ion-buttons class="address-actions">
                  <ion-button fill="clear" color="success" size="small" (click)="handleViewAddress(address)">
                    <ion-icon name="eye-outline" slot="icon-only"></ion-icon>
                  </ion-button>
                  <ion-button fill="clear" color="primary" size="small" (click)="handleEditAddress(address)">
                    <ion-icon name="create-outline" slot="icon-only"></ion-icon>
                  </ion-button>
                  <ion-button fill="clear" color="danger" size="small" (click)="handleRemoveAddress(address)">
                    <ion-icon name="trash-outline" color="danger" slot="icon-only"></ion-icon>
                  </ion-button>
                </ion-buttons>

              </ion-card-header>
        
              <ion-card-content class="address-card-content">

                <ion-item lines="none" *ngIf="address?.houseNumber" class="address-line">
                  <ion-label>
                    <ion-text color="medium"><strong>House Number:</strong></ion-text>
                    <ion-text>{{ address.houseNumber }}</ion-text>
                  </ion-label>
                </ion-item>
              
                <ion-item lines="none" *ngIf="address?.buildingName" class="address-line">
                  <ion-label>
                    <ion-text color="medium"><strong>Building Name:</strong></ion-text>
                    <ion-text>{{ address.buildingName }}</ion-text>
                  </ion-label>
                </ion-item>
              
                <ion-item lines="none" *ngIf="address?.address" class="address-line">
                  <ion-label>
                    <ion-text color="medium"><strong>Address:</strong></ion-text>
                    <ion-text>{{ address.address }}</ion-text>
                  </ion-label>
                </ion-item>
              
                <ion-item lines="none" *ngIf="address?.city" class="address-line">
                  <ion-label>
                    <ion-text color="medium"><strong>City:</strong></ion-text>
                    <ion-text>{{ address.city }}</ion-text>
                  </ion-label>
                </ion-item>
              
                <ion-item lines="none" *ngIf="address?.country" class="address-line">
                  <ion-label>
                    <ion-text color="medium"><strong>Country:</strong></ion-text>
                    <ion-text>{{ address.country }}</ion-text>
                  </ion-label>
                </ion-item>
              
                <ion-item lines="none" *ngIf="address?.pinCode" class="address-line">
                  <ion-label>
                    <ion-text color="medium"><strong>Pincode:</strong></ion-text>
                    <ion-text>{{ address.pinCode }}</ion-text>
                  </ion-label>
                </ion-item>
              
                <ion-item lines="none" *ngIf="address?.landmark" class="address-line">
                  <ion-label>
                    <ion-text color="medium"><strong>Landmark:</strong></ion-text>
                    <ion-text>{{ address.landmark }}</ion-text>
                  </ion-label>
                </ion-item>
              
              </ion-card-content>
              
        
            </ion-card>
          </ion-col>
        
        </ion-row>
        

        <ng-template #noAddressContent>

          <div class="no-data bg-light">

            <div class="d-flex justify-content-center align-items-center" style="min-height: 421px;">

              <div class="text-dark text-center">

                <img src="assets/img/no-data.png" alt="No Data" srcset="" style="width: 150px;">

                <ion-label>
                  <h2>No Data Available</h2>

                  <p>There is no address to display at the moment. Please add new address</p>
                  
                </ion-label>

              </div>

            </div>

          </div>
          
        </ng-template>
        
      </div>
    </div> 

  </div>
</ion-content>
